const mobileMediaQuery = '(max-width: 720px)';

function isTextEntryElement(element: Element | null): boolean {
  if (element instanceof HTMLTextAreaElement || element instanceof HTMLSelectElement) return true;
  if (!(element instanceof HTMLInputElement)) return false;
  return !['button', 'checkbox', 'file', 'hidden', 'radio', 'range', 'reset', 'submit'].includes(
    element.type,
  );
}

export function installMobileViewport(): () => void {
  if (typeof window === 'undefined' || !window.visualViewport) return () => undefined;

  const viewport = window.visualViewport;
  let frame = 0;

  const update = () => {
    window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(() => {
      const root = document.documentElement;
      const mobile = window.matchMedia(mobileMediaQuery).matches;
      const editing = mobile && isTextEntryElement(document.activeElement);

      if (editing) {
        root.style.setProperty('--app-viewport-height', `${Math.round(viewport.height)}px`);
        root.style.setProperty(
          '--app-viewport-top',
          `${Math.max(0, Math.round(viewport.offsetTop))}px`,
        );
      } else {
        root.style.removeProperty('--app-viewport-height');
        root.style.removeProperty('--app-viewport-top');
      }
    });
  };

  const updateAfterFocus = () => {
    update();
    window.setTimeout(update, 250);
  };

  viewport.addEventListener('resize', update);
  viewport.addEventListener('scroll', update);
  window.addEventListener('orientationchange', updateAfterFocus);
  document.addEventListener('focusin', updateAfterFocus);
  document.addEventListener('focusout', updateAfterFocus);
  update();

  return () => {
    window.cancelAnimationFrame(frame);
    viewport.removeEventListener('resize', update);
    viewport.removeEventListener('scroll', update);
    window.removeEventListener('orientationchange', updateAfterFocus);
    document.removeEventListener('focusin', updateAfterFocus);
    document.removeEventListener('focusout', updateAfterFocus);
  };
}
